import React, { useEffect } from "react"
import IdleModal from "../common/IdleModal"
import { useDispatch, useSelector } from "react-redux"
import { logoutUser } from "store/auth/action"
import {
  startInactivityTimeout,
  stopInactivityTimeout,
  setShowIdleModal,
} from "store/user/actions"

const IdleChecker = () => {
  const { schoolData } = useSelector((state) => state.schoolReducer)
  const { showIdleModal } = useSelector((state) => state.userReducer)

  const dispatch = useDispatch()

  const handleLogout = () => {
    dispatch(logoutUser())
  }
  const IDLE_MINS = schoolData?.config?.products?.idle_timeout_mins

  const setTimeoutFunction = () => {
    return setTimeout(() => {
      // Dispatch the action to show the idle modal
      dispatch(setShowIdleModal(true))
    }, IDLE_MINS * 60000) // Replace with your desired timeout value
  }

  useEffect(() => {
    if (!IDLE_MINS) return
    // Function to reset the inactivity timer
    const resetInactivityTimer = () => {
      dispatch(stopInactivityTimeout())
      dispatch(startInactivityTimeout(setTimeoutFunction())) // Show the modal after seconds of inactivity // replace with IDLE_MINS
    }

    // Attach event listeners to track activity
    window.addEventListener("mousemove", resetInactivityTimer)
    window.addEventListener("keydown", resetInactivityTimer)
    window.addEventListener("keyup", resetInactivityTimer)
    window.addEventListener("click", resetInactivityTimer)
    window.addEventListener("onmousewheel", resetInactivityTimer)
    window.addEventListener("onscroll", resetInactivityTimer)
    window.addEventListener("scroll", resetInactivityTimer)

    // Initial timer start
    resetInactivityTimer()

    return () => {
      // Remove event listeners when the component unmounts
      window.addEventListener("mousemove", resetInactivityTimer)
      window.addEventListener("keydown", resetInactivityTimer)
      window.addEventListener("keyup", resetInactivityTimer)
      window.addEventListener("click", resetInactivityTimer)
      window.addEventListener("onmousewheel", resetInactivityTimer)
      window.addEventListener("onscroll", resetInactivityTimer)
      window.addEventListener("scroll", resetInactivityTimer)
      resetInactivityTimer()
      dispatch(stopInactivityTimeout())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [IDLE_MINS, dispatch])

  const handleClose = () => {
    dispatch(setShowIdleModal(false))
  }
  return (
    <IdleModal
      isOpen={showIdleModal}
      onClickCancel={() => handleClose()}
      closeModal={() => handleClose()}
      logoutAction={() => handleLogout()}
      idleMins={IDLE_MINS}
    />
  )
}

export default IdleChecker
